import styled from 'styled-components';

export const StyledBackground = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;

  background-image: url('/images/icons/404-background.svg');
  background-repeat: no-repeat, repeat;
  background-position: center;
  position: relative;
  padding: 20px;
  font-family: 'Poppins';

  h1 {
    font-size: ${({ theme }) => theme.fontSizes.largest};
  }

  h3 {
    font-size: 90px;
  }

  p {
    font-size: ${({ theme }) => theme.fontSizes.normal};
  }
`;
export const ContentWrapperStyled = styled.div`
  max-width: 650px;
  margin: 0 auto;
`;

export const StyledImage = styled.img`
  width: 100%;
`;
